/**
 * 创建人：zll
 * 时间：2020-9-28
 * 描述：时间线组件
 * 使用说明: 参考 sw-timeline 配置应用说明文档 
 * 更新记录: 
 * 
 */
import { Input,Component, OnInit, HostListener, ElementRef,Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';
declare var $:any;

/**
 * 自选表单字段右移动组件   sw-timeline
 */
@Component({
  selector: 'sw-timeline',
  templateUrl: './sw-timeline.component.html',
  styleUrls: ['./sw-timeline.component.css']
})
export class SwTimelineComponent implements OnInit {
 
  /**
   * 案例：
   * [
   * {id:"1",icon:"icon iconfont iconbtn_message",type:"bg-blue",createTime:'2020-09-28',detailCreateTime:'2020-09-28',detailTime:"12:05:03",title:{titleName:"小团队",titleContent:"发送邮件"},content:"我是内容",footer:'我是底部'},
   * ]
   * icon: 为图标class  
   * type:图标类型  bg-blue bg-gray  bg-gray-light bg-black bg-red bg-yellow bg-aqua bg-blue bg-light-blue bg-green bg-navy bg-teal bg-olive bg-lime bg-orange bg-fuchsia bg-purple bg-maroon
   * createTime: 创建时间  
   * detailTime: 具体时间 可以为空 前端操作 （可以没有该字段）
   * title 格式不限 可以为空 前端操作 （可以没有该字段）
   * content 格式不限 可以为空 前端操作（可以没有该字段）
   * footer 格式不限 可以为空 前端操作（可以没有该字段）
   * 点击的标题
   * @ignore 
   */
  @Input() datas:any =[] 

   /**
   * 时间线是否有图标 true为有图标 false为没有图标为默认样式
   * @ignore 
   */
  @Input() isHasIcon: boolean = false; 

  /**
   * 显示数据
   * @ignore
   */
  @ContentChild('line') lineTmpl: TemplateRef<any>;
  /**
   * @ignore
   */
  constructor(private _elementRef: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
   
  }
 
  /**
   * @ignore
   */
  ngAfterViewInit(){
    
  }
  
 
}
